export type OrganizationIdentifier = "Global" | "Cic" | "Uri" | "Agb" | undefined;

export interface AuthorizationOrganization {
    organizationId: number;
    agbCode: string | null;
    cicCode: number | null;
    mrdmUri: string | null;
    name: string;
    position: string;
    product: string;
}

export interface AuthorizationPermission {
    product: string;
    permissions: string[];
}

export interface AuthorizationExtendedPermission
    extends AuthorizationPermission,
        AuthorizationOrganization {
    applicationInstance: string;
}

export interface AuthorizationProfile {
    accountId: number;
    email: string;
    firstName: string;
    lastName: string;
    organizations: AuthorizationOrganization[];
    isDisabled: boolean;
    isInternal: boolean;
    metadata: Record<string, string>;
    impersonation: { originalUserName: string; originalUserEmail: string };
}
